import React from "react";

function TermsConditions() {
  return (
    <main className="policy-page">
      <div className="container-fluid px-lg-5">
        <div className="row justify-content-center">
          <div className="col-xl-9 col-lg-10">

            {/* Header */}
            <header className="policy-header text-center mb-5">
              <h1>Terms & Conditions</h1>
              <p className="policy-subtitle">
                Please read these terms carefully before using the EnergyIndia
                power and energy industry directory.
              </p>
            </header>

            {/* Content */}
            <section className="policy-content">

              <article>
                <h2>1. Acceptance of Terms</h2>
                <p>
                  By accessing or using <strong>EnergyIndia</strong>, you agree to
                  be bound by these Terms & Conditions and all applicable laws
                  and regulations.
                </p>
              </article>

              <article>
                <h2>2. Platform Purpose</h2>
                <p>
                  EnergyIndia serves as an informational directory for
                  cogeneration plants, power generation units, renewable energy
                  facilities, and associated agencies. The information provided
                  is for reference purposes only.
                </p>
              </article>

              <article>
                <h2>3. User Responsibilities</h2>
                <ul>
                  <li>Ensure accuracy of information submitted</li>
                  <li>Use the platform only for lawful and professional purposes</li>
                  <li>Do not misuse or attempt to disrupt platform operations</li>
                </ul>
              </article>

              <article>
                <h2>4. Intellectual Property</h2>
                <p>
                  All content, design elements, logos, and data on EnergyIndia
                  are the intellectual property of their respective owners and
                  may not be copied or reproduced without permission.
                </p>
              </article>

              <article>
                <h2>5. Information Accuracy</h2>
                <p>
                  While we strive to maintain accurate and up-to-date data,
                  EnergyIndia does not guarantee the completeness or accuracy of
                  listed information.
                </p>
              </article>

              <article>
                <h2>6. Limitation of Liability</h2>
                <p>
                  EnergyIndia shall not be liable for any direct, indirect,
                  incidental, or consequential damages arising from the use or
                  inability to use the platform.
                </p>
              </article>

              <article>
                <h2>7. External Links</h2>
                <p>
                  The platform may contain links to third-party websites.
                  EnergyIndia has no control over external content and assumes
                  no responsibility for it.
                </p>
              </article>

              <article>
                <h2>8. Modifications to Terms</h2>
                <p>
                  EnergyIndia reserves the right to modify these Terms &
                  Conditions at any time. Continued use of the platform implies
                  acceptance of updated terms.
                </p>
              </article>

              <article>
                <h2>9. Governing Law</h2>
                <p>
                  These Terms & Conditions shall be governed by and interpreted
                  in accordance with the laws of India.
                </p>
              </article>

              <article>
                <h2>10. Contact Information</h2>
                <p>
                  For any questions regarding these Terms & Conditions, please
                  contact:
                  <br />
                  <strong>Email:</strong> anekant.prakashan@gmail.com
                </p>
              </article>

            </section>

          </div>
        </div>
      </div>
    </main>
  );
}

export default TermsConditions;
